module.exports = __webpack_public_path__ + "static/chicken-20cb96afcf44d953fabf6628bdf18d44.svg";